import { getCssVar } from '../utils';
let flagUrl = null;
export const getFlagUrl = (root, code) => {
  if (code === null || code.length === 0) {
    return '';
  }
  if (flagUrl === null) {
    flagUrl = getCssVar(root, '--sinch-flag-src-url');
    if (flagUrl !== null) {
      flagUrl = flagUrl.replaceAll('"', '').trim();
    }
  }
  if (flagUrl === null) {
    return '';
  }
  return flagUrl.replace('%s', code);
};